"use client";
import { jsx as h } from "react/jsx-runtime";
import { memo as c } from "react";
import a from "../components/Icon/SvgIcon.js";
const e = (o) => /* @__PURE__ */ h(
  a,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ h(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M20.361 16.354h-.257a2.395 2.395 0 0 0-2.305-1.77 2.395 2.395 0 0 0-2.303 1.77h-.646V9.231h3.547c.091 0 .178.031.246.088l.274.525h-2.104a.625.625 0 0 0-.625.625v2.737c0 .343.28.625.625.625h3.937v2.134a.39.39 0 0 1-.389.389m-1.62 1.25a1.13 1.13 0 0 1-.942.529c-.399 0-.734-.217-.94-.529a1.1 1.1 0 0 1-.208-.621c0-.236.09-.445.214-.629.206-.305.539-.52.934-.52.397 0 .729.215.936.52.124.184.214.393.214.629 0 .234-.088.439-.208.621m1.603-5.023h-2.906v-1.487h2.131zM13.6 8.606v7.748H8.751a2.4 2.4 0 0 0-2.304-1.77 2.396 2.396 0 0 0-2.305 1.77h-.257a.636.636 0 0 1-.635-.637v-8.83c0-.351.285-.637.635-.637h9.08c.35 0 .635.286.635.637zm-7.153 9.527a1.15 1.15 0 0 1 0-2.299 1.15 1.15 0 0 1 0 2.299m15.252-5.658-1.992-3.82a.7.7 0 0 0-.087-.127 1.64 1.64 0 0 0-1.223-.547H14.85V6.887A1.89 1.89 0 0 0 12.965 5h-9.08C2.845 5 2 5.848 2 6.887v8.83c0 1.041.845 1.887 1.885 1.887h.254a2.4 2.4 0 0 0 2.308 1.779 2.4 2.4 0 0 0 2.307-1.779h6.739a2.395 2.395 0 0 0 2.306 1.779 2.396 2.396 0 0 0 2.308-1.779h.254A1.64 1.64 0 0 0 22 15.965v-2.263c0-.424-.104-.846-.301-1.227",
        clipRule: "evenodd"
      }
    )
  }
), t = c(e);
export {
  t as Truck,
  t as default
};
